import {
  Box
} from '@mui/material';
import { isValidUser } from 'OnlyWithFunctions';
import CustomModal from 'UI/CustomModal';
import SendModal from 'UI/SendModal';
import { listaTipiRichiesteSupporto } from "enums/constants-richieste-supporto";
import { useEffect, useState } from 'react';
import { sendRichiestaSupporto } from 'services/sendRichiestaSupporto';
import { useRichiestaSupportoStore } from 'stores/richiesta-supporto-store';

function Supporto({ idPratica, modalOpen, handleMod, rispostaSupporto, assegnatario }) {
  const [modalStatus, setModalStatus] = useState(modalOpen);

  const { store: richiestaSupportoStore } = useRichiestaSupportoStore();

  useEffect(() => {
    setModalStatus(modalOpen);
  }, [modalOpen]);

  const [save, setSave] = useState(false);
  const [loading, setLoading] = useState(false);
  const [infoMessage, setInfoMessage] = useState('');
  const [error, setError] = useState(false);

  const richiedenteSupportoConsulenziale = JSON.parse(localStorage.getItem('user'));
  const richiesta = "";

  const getGroupTypeOfUser = () => {
    for (let i = 0; i < listaTipiRichiesteSupporto.length; i++) {
      const tipoRichiesta = listaTipiRichiesteSupporto[i];
      const ruoli = tipoRichiesta.ruoli;
      for (let j = 0; j < ruoli.length; j++) {
        if (isValidUser(ruoli[j])) {
          return tipoRichiesta.codice;
        }
      }
    }
    return null;
  }

  const groupType = getGroupTypeOfUser();

  // START parte Handlers

  const handleChangeModal = () => {
    setModalStatus(false);
    handleMod();
  };

  const handleSendRichiestaSupporto = (richiestaSupporto) => {
    let dati = richiestaSupporto;

    if (rispostaSupporto) {
      dati = {
        ...dati, idRichiestaSupporto: richiestaSupportoStore.idRichiestaSupporto,
        destinatario: richiestaSupportoStore.utenteUltimaRichiestaSupporto,
        groupsId: null
      }
    } else {
      dati = { ...dati, destinatario: dati.groupsId[0] }
    }

    setSave(true);
    setLoading(true);
    setModalStatus(false);
    setInfoMessage('Salvataggio in corso');

    sendRichiestaSupporto(dati)
      .then(response => {
        setLoading(false);
        setInfoMessage(response.data.message);
        setError(response.data.code !== 200);
        setTimeout(() => {
          setInfoMessage('')
          window.location.reload();
          handleMod();
        }, 1000);
      })
      .catch(() => {
        setLoading(false);
        setInfoMessage('Errore durante l\'invio della richiesta, se persiste contattare l\'amministratore');
        setError(true);
        setTimeout(() => {
          setSave(false);
          setInfoMessage('')
        }, 5000);
      });
  };

  // END parte Handlers

  return (
    <Box>
      {/* Modal */}
      <SendModal
        open={modalStatus}
        groupType={groupType}
        richiedenteSupportoConsulenziale={richiedenteSupportoConsulenziale}
        value={richiesta}
        onClick={handleChangeModal}
        idPratica={idPratica}
        onSubmit={handleSendRichiestaSupporto}
        rispostaSupporto={rispostaSupporto}
      />

      <CustomModal open={save} loading={loading} error={error} message={infoMessage} />
    </Box>
  );
}

export default Supporto;